<div *ngIf="internalFilter && filterConfig" (clickOutside)="setEditing(false)">
	<div class="active-filter-box">
		<div class="field-name">
			<span class="remove-filter">
				<i class="fa fa-times-circle" (click)="removeFilter()"></i>
			</span>
			<span>{{ filterConfig.label }}</span>
		</div>
		<div (click)="setEditing(!editing); focusInput(facetList)" class="selection">
			<span *ngIf="filterConfig.type === 'date'">
				{{ dateOption | translate }} {{ date | date }}
			</span>
			<span *ngIf="filterConfig.property === 'publicationid'">
				<span *ngFor="let value of internalFilter.value; let i = index">
					{{ value | sharedPublicationIdToName | async }}{{ i === internalFilter.value.length -1 ? '' : ', ' }}
				</span>
			</span>
			<span *ngIf="filterConfig.type !== 'date' && filterConfig.property !== 'publicationid'">
				<span *ngFor="let value of internalFilter.value; let i = index">
					{{ determineLabelForValue(value) }}{{ i === internalFilter.value.length - 1 ? '':', ' }}
				</span>
				<span [hidden]="internalFilter.value && internalFilter.value.length">{{ 'ALL' | translate }}</span>
			</span>
			<span class="dropdown-toggle">
				<i class="fa fa-chevron-down"></i>
			</span>
		</div>
	</div>
	
	<div class="dropdown" *ngIf="editing">
		<ng-container [ngSwitch]="filterConfig.type">
			<div class="date-selector" *ngSwitchCase="'date'">
				<bb-datepicker
					#datePicker
					[initialDate]="date"
					[initialOpen]="true"
					[(ngModel)]="date"
					(ngModelChange)="filterChanged($event)">
					<div class="date-options">
						<button class="button" (click)="setCompareOption('BEFORE')" [ngClass]="{active: dateOption === 'BEFORE'}">{{ 'BEFORE' | translate }}</button>
						<button class="button" (click)="setCompareOption('ON')" [ngClass]="{active: dateOption === 'ON'}">{{ 'ON' | translate }}</button>
						<button class="button" (click)="setCompareOption('AFTER')" [ngClass]="{active: dateOption === 'AFTER'}">{{ 'AFTER' | translate }}</button>
					</div>
				</bb-datepicker>
			</div>
			<div class="text-filter" *ngSwitchCase="'text'">
				<input #textSearchInput type="text" autofocus [(ngModel)]="textSearchValue" (keyup.enter)="doTextSearch()"/>
				<i class="fa fa-times close-icon" (click)="textSearchValue='';doTextSearch()" [hidden]="textSearchValue===''"></i>
			</div>
			<bb-facet-list *ngSwitchDefault #facetList [valueLabelMap]="valueLabelMap" [facetsLoading]="facetsLoading" [options]="options" [(ngModel)]="internalFilter.value" (ngModelChange)="filterChanged()"></bb-facet-list>
		</ng-container>
	</div>
</div>
